export default {
    documents: {
        title: 'Documents',
        loading: 'Loading documents...',
        retry: 'Retry',
        noDocuments: 'No documents yet',
        createFirst: 'Create your first document',

        // Document types
        types: {
            disclosure: 'Disclosure',
            patent_draft: 'Patent Draft',
            prosecution: 'Prosecution',
            patent_claim: 'Patent Claim',
            specification: 'Specification',
            rejection_comparison: 'Rejection Comparison',
            technical_doc: 'Technical Doc',
            other: 'Other',
        },

        // Time formatting
        time: {
            today: 'Today',
            yesterday: 'Yesterday',
            daysAgo: '{count} days ago',
        },

        // Actions
        actions: {
            delete: 'Delete',
            edit: 'Edit',
            download: 'Download',
            open: 'Open',
        },

        // Rename dialog
        rename: {
            title: 'Rename document',
            confirm: 'Save',
            cancel: 'Cancel',
            inputErrorMessage: 'Please enter a document name',
        },

        // Content preview
        preview: {
            noContent: 'No content',
            wordCount: '{count} words',
        },

        // Delete confirmation
        deleteConfirm: {
            title: 'Delete Document',
            message: 'Are you sure you want to delete "{title}"?',
            confirm: 'Delete',
            cancel: 'Cancel',
        },

        // Messages
        deleteSuccess: 'Document deleted successfully',
        renameSuccess: 'Document renamed successfully',
        downloadSuccess: 'Document downloaded successfully',

        // Errors
        errors: {
            loadFailed: 'Failed to load documents',
            openFailed: 'Failed to open document',
            deleteFailed: 'Failed to delete document',
            renameFailed: 'Failed to rename document',
            downloadFailed: 'Failed to download document',
        },
    },
};
